import React, { FC } from 'react';
import SelectorBody from './components/selector-body.component';
import SelectorHeader from './components/selector-header.component';
import Page from '../../components/page/page.component';

const LoginSelectorPage: FC = () => {
  return (
    <Page pageTitle='Login Selector'>
      <SelectorHeader />
      <SelectorBody />
    </Page>
  );
};

export default LoginSelectorPage;
